import OriginFilter from '@/language/pt/components/filter/OriginFilter';
import FieldFilter from '@/language/pt/components/filter/FieldFilter';
import OperationFilter from '@/language/pt/components/filter/OperationFilter';
import SortingFilter from '@/language/pt/components/filter/SortingFilter';
import ComponentTypeFilter from '@/language/pt/components/filter/ComponentTypeFilter';
import WidthFilter from '@/language/pt/components/filter/WidthFilter';
import HeightFilter from '@/language/pt/components/filter/HeightFilter';

export default {
  OriginFilter,
  FieldFilter,
  OperationFilter,
  SortingFilter,
  ComponentTypeFilter,
  WidthFilter,
  HeightFilter,
};
